<template>
    <div class="body flex">
        <div class="subtitle">{{title}}</div>
        <div class="more flex" v-if="isMore" @click="toMore">
            <div class="more-title">查看更多</div>
            <van-icon name="arrow" class="more-logo"/>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant'

export default {
    name: 'Subtitle',
    props: {
        title: {
            type: String
        },
        path: {
            type: String,
            default: ''
        }
    },
    computed:{
        isMore(){
            return this.path && this.path !== ''
        }
    },
    methods:{
        toMore(){
            const path = this.path
            if(!path) return Toast.fail('未设置\npath')
            this.$router.push(path)
        }
    }
}
</script>

<style scoped>
.body {
    position: relative;
    margin-bottom: 10px;
}

.more {
    line-height: 25px;
    position: absolute;
    right: 0;
    color: #4E4E4E;
    font-size: 14px;
}

.more-title {
    color: #4E4E4E;
    font-size: 14px;
}

.more-logo {
    line-height: 25px;
    line-height: 25px;
    font-size: 18px;
}
</style>
